export default "__VITE_ASSET__a85e95b0__"